module.exports = __webpack_public_path__ + "static/bg_agency-b81953fba2461f2821f9fbd72655ecc2.jpg";